import { createSlice } from '@reduxjs/toolkit';

export const ActionTipoNovedadSlice = createSlice({
    name: 'actionTipoNovedad',
    initialState: {
        actionTipoNovedades_list: [],
        actionTipoNovedad: {},
        actionTipoNovedadesSelect: [],
    },
    reducers: {
        setActionTipoNovedadesRedux: ( state, { payload } ) => {
            state.actionTipoNovedades_list  =  payload;
        }, 
        storeActionTipoNovedadRedux: ( state, { payload } ) => {
            state.actionTipoNovedad  =  payload;
        },
        storeActionTipoNovedadSelectRedux: ( state, { payload } ) => {
            state.actionTipoNovedadesSelect  =  payload;
        }
        
    }
});


// Action creators are generated for each case reducer function
export const { setActionTipoNovedadesRedux, storeActionTipoNovedadRedux, storeActionTipoNovedadSelectRedux } = ActionTipoNovedadSlice.actions;